export abstract class LaneEntitySpine extends window.SpinePlugin.SpineGameObject {
  protected isInUse: boolean;
  protected hasBeenHit: boolean;
  protected spawnOffsetY: number;

  constructor(scene: Phaser.Scene, x: number, y: number, spine: string, animationName?: string, loop?: boolean) {
    super(scene, scene.sys.spine, x, y, spine, animationName, loop);

    this.isInUse = false;
    this.hasBeenHit = false;
    this.spawnOffsetY = 0;
  }

  get HasBeenHit() {
    return this.hasBeenHit;
  }

  public abstract init(): void;

  public reset() {
    this.alpha = 1;
    // this.setScale(1);
    this.setVisible(true);
    this.setActive(true);

    this.hasBeenHit = false;
  }

  public recycle() {
    this.scene.tweens.killTweensOf(this);
    // this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);
    // this.destroy();
  }

  public onHit(wasPlayer: boolean, hitPointX: number, delay: number) {
    this.scene.add.tween({
      targets: this,
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Circular.InOut,
      delay: delay,
      onComplete: () => {
        this.hasBeenHit = true;
      },
      onCompleteScope: this
    });
  }
}
